function isMobileDevice() {
    return window.matchMedia("only screen and (max-width: 768px)").matches;
} 

$(document).ready(function () {
    $(".logo-slider").slick({
        infinite: false,
        slidesToShow: 6,
        swipeToSlide: true,
        infinite: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: true,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                infinite: true
            }
        }, {
            breakpoint: 800,
            settings: {
                slidesToShow: 4,
                dots: true
            }
        }, {
            breakpoint: 300,
            settings: "unslick" // destroys slick

        }]
    });

    $(document).on('change', '.drawer__footer .ath-check', function () {
        var target = $("cart-drawer-items #cartAtl");
        if (!this.checked) {
            target.attr("value", "No");
            $("#cartAtl1")?.attr("value", "No");
        } else {
            target.attr("value", "Yes");
            $("#cartAtl1")?.attr("value", "Yes");
        }
    })

    $(document).on('change', '.cart__footer #checkboxAtl1', function () {
        console.log("cart checkbox")
        var target = $("cart-items #cartAtl1");
        if (this.checked) {
            target.attr("value", "Yes")
        } else {
            target.attr("value", "No")
        }
    })


    if (isMobileDevice()) {
        $('.accordion-header').click(function () {
            var $currentHeader = $(this);
            var $currentContent = $currentHeader.next('.accordion-content');
            
            // Check if the current content is already visible
            if ($currentHeader.parent().hasClass('active')) {
                // If it's active, slide it up and remove the active class
                $currentContent.slideUp();
                $currentHeader.parent().removeClass('active');
            } else {
                // If it's not active, remove active class from all and slide up all contents
                $('.accordion-header').parent().removeClass("active");
                $('.accordion-header').next('.accordion-content').slideUp();
                
                // Then add active class to the clicked header's parent and slide down its content
                $currentHeader.parent().addClass('active');
                $currentContent.slideDown();
            }
        });
    }

    $(".cart-shipping-calc .docapp-shipping-show-trigger").click(function() {
        $(".cart-shipping-calc").toggleClass("active")
    });

    // Attach a click event handler to the summary element
    $('.header__inline-menu summary').on('click', function () {
        // Find the parent link and get its href attribute
        var linkUrl = $(this).find('.parent-link').attr('href');

        // Redirect to the link URL
        if (linkUrl) {
            window.location.href = linkUrl; // Redirect to the URL
        }
    });
})